var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaklerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-slider.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 5H22V7H13V5ZM2 7H9V9H11V3H9V5H2V7ZM9 17H22V19H9V17ZM19 11H22V13H19V11ZM17 15V9.012H15V11H2V13H15V15H17ZM7 21V15H5V17H2V19H5V21H7Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaklerIcon);
export default __webpack_public_path__ + "static/media/spakler_icon.13883b11f20b0cfeb1112ae7d314ef26.svg";
export { ForwardRef as ReactComponent };